import { render } from "./DisposalApplication.vue?vue&type=template&id=04a3b86a&scoped=true&ts=true"
import script from "./DisposalApplication.vue?vue&type=script&lang=ts"
export * from "./DisposalApplication.vue?vue&type=script&lang=ts"

import "./DisposalApplication.vue?vue&type=style&index=0&id=04a3b86a&lang=less&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-04a3b86a"]])

export default __exports__